import _ from 'lodash';
import { preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { contentfulModels } from '@glowforge/ui-common';
import { fetchMachinesForUser } from 'app/common/api/common-api';
import Printers from 'app/components/settings/printers';
import * as machineSelectors from 'app/selectors/machines';
import { subscriptions } from 'app/selectors/subscriptions';

const { getStringsForPage } = contentfulModels;

const mapStateToProps = state => ({
  machines: machineSelectors.getMachineList(state),
  isLoading: _.get(state, 'common.machinesLoading') || !BROWSER,
  isRestricted: subscriptions.getIsRestricted(state),
  pageStrings: getStringsForPage(_.get(state, 'accountSettings.settingsPage.fields')),
});

const PrintersContainer = connect(mapStateToProps)(preload(
  ({ dispatch, getState }) => {
    if (!_.get(getState(), 'common.machinesLoading')) {
      dispatch(fetchMachinesForUser());
    }
    return Promise.resolve();
  }, { client: true, blocking: false })(Printers),
);

export default PrintersContainer;



// WEBPACK FOOTER //
// ./app/containers/settings/printers.js